import script from "./PullRequestMergeForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./PullRequestMergeForm.vue?vue&type=script&lang=ts&setup=true"

import "./PullRequestMergeForm.vue?vue&type=style&index=0&id=68bc305e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68bc305e"]])

export default __exports__